<script lang="ts" setup>
import { Button } from '~ds/components/ui/button';
import { Text } from '~ds/components/ui/typography';
import { useI18n } from 'vue-i18n';

const emit = defineEmits<{
  startAgain: [];
}>();

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col items-center gap-4">
    <Text
      class="text-center text-destructive"
      role="alert"
      data-testid="auth-mfa-expired"
    >
      {{ t('kui.auth.mfaExpired') }}
    </Text>
    <Button
      type="button"
      data-testid="auth-mfa-start-again"
      @click="emit('startAgain')"
    >
      {{ t('kui.auth.mfaStartAgain') }}
    </Button>
  </div>
</template>
